import * as Sentry from '@sentry/nextjs';

import { APIRequestLabel } from '../consts';
import { callHttpPost } from '../http';

const like = (get, set) => {
  return async (type: string, entityId: number | string): Promise<boolean> => {
    let payload = {};
    switch (type) {
      case 'GOAL':
        payload = {
          type: 'GOAL',
          goalEntityId: entityId
        };
        break;
      case 'TASK':
        payload = {
          type: 'TASK',
          taskEntityId: entityId
        };
        break;
      case 'MESSAGE':
        payload = {
          type: 'MESSAGE',
          messageId: entityId
        };
        break;
    }
    await callHttpPost(get, set, APIRequestLabel.LIKE, `/likes/like`, payload);

    let apiCallStatus = get().apiCallStatus[APIRequestLabel.LIKE];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      throw new Error('Failed to like the entity');
    }

    if (type == 'GOAL') {
      // update goals
      let goals = get().goals;
      let idx = goals.findIndex((g) => g.entityId === entityId);
      if (idx > -1) {
        goals[idx] = {
          ...goals[idx],
          liked: { isActive: true }
        };
      }
      // update goalsLibrary (used by /goals mentor view for the favourites filter)
      const goalsLibrary = get().goalsLibrary.map((g) =>
        g.entityId === entityId ? { ...g, liked: { isActive: true } } : g
      );
      // update goal
      let goal = get().goal;
      if (goal && goal.entityId === entityId) {
        goal = {
          ...goal,
          liked: { isActive: true }
        };
      }
      // profile goal
      let accountProfile = get().accountProfile;
      let profileGoal = accountProfile?.createdGoals?.find((g) => g.entityId === entityId);
      if (profileGoal) {
        accountProfile = {
          ...accountProfile,
          createdGoals: accountProfile.createdGoals.map((g) => {
            if (g.entityId === entityId) {
              return {
                ...g,
                liked: { isActive: true }
              };
            }
            return g;
          })
        };
      }
      set({ goals: [...goals], goalsLibrary, goal: goal, accountProfile: accountProfile });

      return true;
    }
  };
};

const unlike = (get, set) => {
  return async (type: string, entityId: number | string): Promise<boolean> => {
    let payload = {};
    switch (type) {
      case 'GOAL':
        payload = {
          type: 'GOAL',
          goalEntityId: entityId
        };
        break;
      case 'TASK':
        payload = {
          type: 'TASK',
          taskEntityId: entityId
        };
        break;
      case 'MESSAGE':
        payload = {
          type: 'MESSAGE',
          messageId: entityId
        };
        break;
    }
    await callHttpPost(get, set, APIRequestLabel.UNLIKE, `/likes/unlike`, payload);

    let apiCallStatus = get().apiCallStatus[APIRequestLabel.UNLIKE];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      throw new Error('Failed to unlike the entity');
    }

    if (type == 'GOAL') {
      // update goals
      let goals = get().goals;
      let idx = goals.findIndex((g) => g.entityId === entityId);
      if (idx > -1) {
        goals[idx] = {
          ...goals[idx],
          liked: { isActive: false }
        };
      }

      // update goalsLibrary (used by /goals mentor view for the favourites filter)
      const goalsLibrary = get().goalsLibrary.map((g) =>
        g.entityId === entityId ? { ...g, liked: { isActive: false } } : g
      );
      // update goal
      let goal = get().goal;
      if (goal && goal.entityId === entityId) {
        goal = {
          ...goal,
          liked: { isActive: false }
        };
      }
      // profile goal
      let accountProfile = get().accountProfile;
      let profileGoal = accountProfile?.createdGoals?.find((g) => g.entityId === entityId);
      if (profileGoal) {
        accountProfile = {
          ...accountProfile,
          createdGoals: accountProfile.createdGoals.map((g) => {
            if (g.entityId === entityId) {
              return {
                ...g,
                liked: { isActive: false }
              };
            }
            return g;
          })
        };
      }
      set({ goals: [...goals], goalsLibrary, goal: goal, accountProfile: accountProfile });

      return true;
    }
  };
};

export { like, unlike };
